// extracted by mini-css-extract-plugin
export default {"inputWrapper":"Input_inputWrapper__--uqS","label":"Input_label__T20nj","input":"Input_input__rR6hX"};